<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright"><a id="page_vi"></a><span class="smallcaps">THE ILLUMINATOR</span>. Copyright © 2005 by Brenda Rickman Vantrease. All rights reserved. Printed in the United States of America. No part of this book may be reproduced in any manner whatsoever without written permission except in the case of brief quotations embodied in critical articles or reviews. For information, address St. Martin’s Press, 175 Fifth Avenue, New York, N.Y. 10010.</p>
<p class="copyright1"><a href="http://www.stmartins.com" target="_blank">www.stmartins.com</a></p>
<p class="copyright1">Design by Kathryn Parise</p>
<p class="copyright1">Library of Congress Cataloging-in-Publication Data</p>
<p class="copyright1">Vantrease, Brenda Rickman.</p>
<p class="copyright2">The illuminator / Brenda Rickman Vantrease.</p>
<p class="copyright2">       p. cm.</p>
<p class="copyright2">ISBN 0-312-33191-6 (hc)</p>
<p class="copyright2">ISBN 0-312-33192-4 (pbk)</p>
<p class="copyright2">EAN 978-0-312-33192-4</p>
<p class="copyright3">1. Bible—Translating—Great Britain—Fiction. 2. Illumination of books and manuscripts—Fiction. 3. Inheritance and succession—Fiction. 4. Scribes—Fiction. 5. Widows—Fiction. 6. Great Britain—History—14th century—Fiction. I. Title.</p>
<p class="copyright4">PS3622.A675 145 2005</p>
<p class="copyright5">813'.6—dc22                                                                                                 2004030095</p>
<p class="copyright1">10  9  8  7  6  5  4  3</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?65fc5215